import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { FormattedMessage, injectIntl } from 'react-intl';
import s from './ApprovedComponent.module.scss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import classNames from 'classnames';
import Button from 'react-bootstrap/Button';
import { v4 as uuidv4 } from 'uuid';
import { isRequired } from '../../utils';
import Cookies from 'js-cookie';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import InputNumber from '../WSAControls/InputNumber/InputNumber';

const ApprovedSubComponent = ({
  isEdit,
  selectedApprovedSubComponent,
  changeApprovedSubComponent,
  saveApprovedSubComponent,
  cancelHandler,
  componentSubTypeOptions,
  equationOptions,
  intl
}) => {
  const [localformErrors, setFormErrors] = useState({});
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = selectedApprovedSubComponent;
    saveData.IsEdit = isEdit;
    saveData.isChanged = true;
    saveData.isDeleted = false;

    if (!isEdit) {
      saveData.ApprovedSubComponentId = 0;
      saveData.GuidIdentifier = uuidv4();
    }
    //saving Model Variant
    cancelHandler();
    saveApprovedSubComponent(saveData);
  };

  const validateInput = () => {
    let formErrors = {};
    let isValid = true;

    if (!selectedApprovedSubComponent || !selectedApprovedSubComponent.ModelSubComponentTypeId) {
      formErrors.ModelSubComponentTypeId = intl.formatMessage({
        id: 'approvedComponents.subComponentTypeRequired',
        defaultMessage: 'Approved sub component is a mandatory field'
      });
      isValid = false;
    }

    if (
      selectedApprovedSubComponent &&
      selectedApprovedSubComponent.SignalTranslationRequired &&
      !selectedApprovedSubComponent.SignalTranslationEquationId
    ) {
      formErrors.SignalTranslationEquationId = intl.formatMessage({
        id: 'approvedComponents.signalTranslationEquationRequired',
        defaultMessage: 'SignalTranslation equation is a mandatory field'
      });
      isValid = false;
    }

    setFormErrors(formErrors);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    changeApprovedSubComponent({
      selectedSubApprovedComponent: { ...selectedApprovedSubComponent, [e.target.name]: e.target.value }
    });
  };

  const onToggleChange = name => {
    if (name === 'SignalTranslationRequired') {
      changeApprovedSubComponent({
        selectedSubApprovedComponent: { [name]: !selectedApprovedSubComponent.SignalTranslationRequired, isChanged: true }
      });
    }

    if (name === 'Output') {
      changeApprovedSubComponent({
        selectedSubApprovedComponent: { [name]: !selectedApprovedSubComponent.Output, isChanged: true }
      });
    }
  };

  const onDropdownModelComponentTypeChange = e => {
    changeApprovedSubComponent({
      selectedSubApprovedComponent: { ModelSubComponentTypeId: e.value, ApprovedSubComponentName: e.label, isChanged: true }
    });
  };

  const onDropdownSignalTranslationEquationChange = e => {
    changeApprovedSubComponent({ selectedSubApprovedComponent: { SignalTranslationEquationId: e.value, isChanged: true } });
  };

  let ddlClassComponentSubType = localformErrors && localformErrors.ModelSubComponentTypeId ? s.ddlError : '';
  let ddlClassSignalTranslationEquation = localformErrors && localformErrors.SignalTranslationEquationId ? s.ddlError : '';
  let isSignalTranslationReq = selectedApprovedSubComponent.SignalTranslationRequired || false;
  let isOutputReq = selectedApprovedSubComponent.Output || false;

  const labelUnchecked = <FormattedMessage id="common.no" defaultMessage="No" />;
  const labelChecked = <FormattedMessage id="common.yes" defaultMessage="Yes" />;

  let saveText = <FormattedMessage id="approvedComponents.addApprovedSubComponents" defaultMessage="ADD" />;

  if (isEdit) {
    saveText = <FormattedMessage id="approvedComponents.updateApprovedSubComponents" defaultMessage="UPDATE" />;
  }

  return (
    <div className={s.approvedComponent}>
      <div className={s.approvedSubComponentContent}>
        <div className={s.topRow}>
          <Row>
            <hr />
          </Row>
          <Row>
            <Col lg={4}>
              <Form.Group controlId="formComponentType">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.approvedSubComponents" defaultMessage="Approved Sub Components" />
                </Form.Label>
                <Dropdown
                  id="ddlComponentSubType"
                  dataArray={componentSubTypeOptions}
                  controlData={{
                    placeholderText: <FormattedMessage id="approvedComponents.pleaseSelectOne" defaultMessage="Please select one" />,
                    customClassName: ddlClassComponentSubType
                  }}
                  onDropdownChange={onDropdownModelComponentTypeChange}
                  selectedOption={componentSubTypeOptions.filter(
                    option => option.value === selectedApprovedSubComponent.ModelSubComponentTypeId
                  )}
                  data-unittest="ddlComponentType"
                />
                {localformErrors && localformErrors.ModelSubComponentTypeId && (
                  <p role="alert" className={s.error}>
                    {localformErrors.ModelSubComponentTypeId}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <Form.Group controlId="formApprovedComponentSignalTranslationRequired">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.signalTranslationRequired" defaultMessage="SignalTranslation required" />
                </Form.Label>
                <ToggleSwitch
                  id="SignalTranslationRequired"
                  handleClick={() => {
                    onToggleChange('SignalTranslationRequired');
                  }}
                  classname={s.switch}
                  checked={selectedApprovedSubComponent.SignalTranslationRequired}
                  labelChecked={labelChecked}
                  labelUnchecked={labelUnchecked}
                  labelPosition="Right"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <Form.Group>
                <Form.Label>
                  <FormattedMessage id="approvedComponents.signalTranslationFrequency" defaultMessage="SignalTranslation frequency" />
                </Form.Label>
                <Form.Control
                  type="text"
                  disabled={!isSignalTranslationReq}
                  name="SignalTranslationFrequency"
                  onChange={onChange}
                  value={selectedApprovedSubComponent.SignalTranslationFrequency || ''}
                  className={`${s.formControl}`}
                  placeholder={intl.formatMessage({
                    id: 'approvedComponents.signalTranslationFrequency',
                    defaultMessage: 'SignalTranslation frequency'
                  })}
                />
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group controlId="formApprovedComponentSignalTranslationTolerance">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.signalTranslationTolerance" defaultMessage="SignalTranslation tolerance" />
                </Form.Label>
                <Row>
                  <Col>
                    <InputNumber
                      disabled={!isSignalTranslationReq}
                      name="SignalTranslationAcceptedErrorTolerance"
                      step=".1"
                      onInputChange={onChange}
                      customClassName={s.formControl}
                      value={selectedApprovedSubComponent.SignalTranslationAcceptedErrorTolerance?.toString()}
                      label="%"
                      id="SignalTranslationTolerance"
                      placeholder={intl.formatMessage({
                        id: 'approvedComponents.signalTranslationTolerance',
                        defaultMessage: 'SignalTranslation tolerance'
                      })}
                    />
                  </Col>
                  <Col className={s.verticalAlign}>
                    <div className={s.calTolerance}>%</div>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group controlId="formSignalTranslationEquation">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.signalTranslationEquation" defaultMessage="SignalTranslation equation" />
                </Form.Label>
                <Dropdown
                  id="ddlSignalTranslationEquation"
                  dataArray={equationOptions}
                  controlData={{
                    placeholderText: <FormattedMessage id="approvedComponents.pleaseSelectOne" defaultMessage="Please select one" />,
                    customClassName: ddlClassSignalTranslationEquation
                  }}
                  onDropdownChange={onDropdownSignalTranslationEquationChange}
                  selectedOption={equationOptions.filter(option => option.value === selectedApprovedSubComponent.SignalTranslationEquationId)}
                  data-unittest="ddlComponentType"
                  disabled={!isSignalTranslationReq}
                />
                {localformErrors && localformErrors.SignalTranslationEquationId && (
                  <p role="alert" className={s.error}>
                    {localformErrors.SignalTranslationEquationId}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={3}>
              <Form.Group controlId="formApprovedComponentOutput">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.output" defaultMessage="Output" />
                </Form.Label>
                <ToggleSwitch
                  id="Output"
                  handleClick={() => {
                    onToggleChange('Output');
                  }}
                  classname={s.switch}
                  checked={selectedApprovedSubComponent.Output}
                  labelChecked={labelChecked}
                  labelUnchecked={labelUnchecked}
                  labelPosition="Right"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <Form.Group controlId="formApprovedComponentOutputLowRange">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.outputLowRange" defaultMessage="Output low range" />
                </Form.Label>
                <InputNumber
                  disabled={!isOutputReq}
                  name="OutputRangeLow"
                  step=".1"
                  onInputChange={onChange}
                  customClassName={s.formControl}
                  value={selectedApprovedSubComponent.OutputRangeLow?.toString()}
                  id="OutputRangeLow"
                  placeholder={intl.formatMessage({
                    id: 'approvedComponents.outputLowRange',
                    defaultMessage: 'Output low range'
                  })}
                />
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group controlId="formApprovedComponentOutputHighRange">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.outputHighRange" defaultMessage="Output high range" />
                </Form.Label>
                <InputNumber
                  disabled={!isOutputReq}
                  name="OutputRangeHigh"
                  step=".1"
                  onInputChange={onChange}
                  customClassName={s.formControl}
                  value={selectedApprovedSubComponent.OutputRangeHigh?.toString()}
                  id="OutputRangeHigh"
                  placeholder={intl.formatMessage({
                    id: 'approvedComponents.outputHighRange',
                    defaultMessage: 'Output high range'
                  })}
                />
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group controlId="formApprovedComponentOutputUnitOfMeasure">
                <Form.Label>
                  <FormattedMessage id="approvedComponents.outputUOM" defaultMessage="Output unit of measure" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="OutputUnitOfMeasure"
                  onChange={onChange}
                  value={selectedApprovedSubComponent.OutputUnitOfMeasure}
                  className={`${s.formControl}`}
                  placeholder={intl.formatMessage({
                    id: 'approvedComponents.outputUOM',
                    defaultMessage: 'Output unit of measure'
                  })}
                  disabled={!isOutputReq}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Button
                variant="primary"
                className={classNames(s.margin5, s.btnSaveChangesSmall)}
                onClick={submitForm}
                noValidate
                data-unittest="saveData"
              >
                {saveText}
              </Button>
              <Button
                variant="outline-secondary"
                className={classNames(s.btnCancelSmall)}
                onClick={cancelHandler}
                noValidate
                data-unittest="saveCancel"
              >
                <FormattedMessage id="signalTranslationEquation.constant.cancel" defaultMessage="CANCEL" />
              </Button>
            </Col>
            <Col lg={8}></Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(ApprovedSubComponent);
